import { STATUS_COLORS } from "@/lib/constants";

export function StatusBadge({ status, className = "" }) {
  const color = STATUS_COLORS[status] || "bg-slate-500/15 text-slate-300 border-slate-500/30";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-widest ${color} ${className}`}
    >
      {String(status).replace(/_/g, " ")}
    </span>
  );
}
